import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import MenuIcon from '@mui/icons-material/Menu';
import LanguageIcon from '@mui/icons-material/Language';
import { Typography } from '@mui/material';


type Anchor = 'top' | 'left' | 'bottom' | 'right';

export default function MobileNav({ children }: any) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250, display: 'flex', justifyContent: 'center', flexDirection: 'column', }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Typography sx={{ textAlign: 'center', mt: 5 }} variant="h6"> <LanguageIcon fontSize='large'/> Sales Packet </Typography>
      <List sx={{ p: 5 }}>
        { children }
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' }  }}>
        <React.Fragment key={'left'}>
          <Button onClick={toggleDrawer('left', true)}><MenuIcon sx={{ color: 'white', ml: 5, display: { xs: 'block', sm: 'block', md: 'none' } }}/></Button>
          <Drawer
            anchor={'left'}
            open={state['left']}
            onClose={toggleDrawer('left', false)}
          >
            {list('left')}
          </Drawer>
        </React.Fragment>
    </Box>
  );
}
